export const countryOptions:any = [
    { value: "US", label: "United States of America" }   
]